import Config from './src/config';
import genderTypeMap from './src/genderTypeMap';
import onboardingQuestionMap from './src/onboardingQuestionMap';
import {
  renderBodyStatTypes,
  renderBodyStatUnits,
  bodyStatTypeMap,
} from './src/bodyStatTypeMap';

export default Config;

export {
  genderTypeMap,
  renderBodyStatTypes,
  renderBodyStatUnits,
  bodyStatTypeMap,
  onboardingQuestionMap,
};
